'use client'

import { CarouselCardWrapper } from '@components/primitives/Carousel/CarouselCardWrapper'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { type TrackingSources } from '@lib/tracking/TrackingSources'
import type { ReactNode } from 'react'

export default function TreatmentTopicCategoryCardWrapper({
  children,
  path,
  source,
}: {
  children: ReactNode
  path: string
  source: TrackingSources
}) {
  const trackTreatmentTopicClick = () =>
    trackEvent(TrackingEvents.TREATMENT_TOPIC_CATEGORY_CARD_CLICKED, {
      path,
      source,
    })

  return (
    <CarouselCardWrapper onClick={trackTreatmentTopicClick}>
      {children}
    </CarouselCardWrapper>
  )
}
